import React from "react";

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    if (import.meta.env?.DEV) {
      console.error("ErrorBoundary:", error, info.componentStack);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="p-8 text-center text-slate-600">
            <div className="text-lg font-semibold mb-2">Etwas ist schiefgelaufen</div>
            <div className="text-sm mb-4">
              Bitte die Seite neu laden oder den Support kontaktieren.
            </div>
            <button
              className="rounded-lg bg-slate-100 px-4 py-2 text-sm hover:bg-slate-200 transition"
              onClick={() => this.setState({ hasError: false })}
            >
              Erneut versuchen
            </button>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
